import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.li`
  ${({ theme }) => css`
    display: flex;
    position: relative;
    align-items: center;
    width: 100%;
    height: 82px;
    cursor: pointer;
    ${theme.mixins.text.select_off};

    &:last-of-type {
      & .list {
        border-bottom: none;
      }

      &::after {
        display: none;
      }
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      z-index: 1;
      bottom: 0;
      left: 50%;
      width: calc(100% - 32px);
      height: 1px;
      transform: translateX(-50%);
      background: ${theme.backgroundColor.divider};
    }
  `}
`;

export const ListInfoWrapper = styled.div<{
  translateX: number;
  isDragging: boolean;
}>`
  ${({ theme, translateX, isDragging }) => css`
    display: block;
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 16px;
    transform: translateX(${translateX}px);
    transition: ${isDragging
      ? 'background 0.1s ease-in-out'
      : 'background 0.1s ease-in-out, transform 0.3s ease-in-out'};
    background: ${theme.backgroundColor.base};

    &:hover {
      background: ${theme.backgroundColor.bg_dark_2};
    }

    &:active {
      filter: brightness(0.8);
      background: ${theme.backgroundColor.bg_dark_3};
    }
  `}
`;

export const ListInfoBox = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 10px 0;
`;

export const Info = styled.div`
  display: flex;
  position: relative;
  flex: 1 1 auto;
  align-items: center;
  justify-content: flex-start;
  width: calc(100% - 59px);
`;

export const ImageBox = styled.div`
  position: relative;
  width: 46px;
  height: 46px;
  border-radius: 50%;

  img {
    width: 46px;
    height: 46px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
  }

  &.multi {
    & > img {
      display: block;
      position: absolute;
      width: 32px;
      height: 32px;

      &:first-of-type {
        z-index: 1;
        top: 0;
        left: 0;
      }

      &:last-of-type {
        z-index: 2;
        right: 0;
        bottom: 0;
      }
    }
  }

  &.alert {
    &::after {
      content: '';
      display: block;
      position: absolute;
      z-index: 3;
      top: 0;
      left: 0;
      width: 12px;
      height: 12px;
      overflow: hidden;
      border-radius: 50%;
      background: #0075ff;
    }
  }
`;

export const DetailBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: calc(100% - 54px);
  margin-left: 8px;
  gap: 4px;
`;

export const NameInfoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  width: 100%;
`;

export const UsersInfoIconBox = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const TotalUsersCount = styled.div`
  ${({ theme }) => css`
    color: ${theme.content.hierarchy3};
    font-size: 14px;
    font-weight: 500;
  `}
`;

export const Name = styled.em`
  ${({ theme }) => css`
    color: ${theme.content.hierarchy1};
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    ${theme.mixins.text.ellipsis_1};

    &.delete {
      color: ${theme.content.content_light_5};
      ${theme.fontStyle.text.body14_medium};
    }
  `}
`;

export const Message = styled.p`
  ${({ theme }) => css`
    color: ${theme.content.hierarchy3};
    font-size: 14px;
    line-height: normal;
    ${theme.mixins.text.ellipsis_2};
    word-break: break-all;

    .italic {
      padding: 0 4px;
      color: #afafb6;
      color: ${theme.content.hierarchy3_reverse};
      font-family: 'Noto Sans', sans-serif;
      font-style: italic;
      font-weight: 500;
      font-optical-sizing: auto;
    }
  `}
`;

export const Time = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  width: 55px;
  height: 100%;
  margin-left: 4px;
  padding-top: 5px;

  & > span {
    display: block;
    color: ${(props) => props.theme.content.hierarchy3};
    ${(props) => props.theme.fontStyle.text.caption_medium};
    text-shadow: 0px 0px 16px rgba(255, 255, 255, 0.2);
  }
`;

export const BehindButtonWrapper = styled.div`
  display: flex;
  position: absolute;
  z-index: 0;
  top: 0;
  right: 0;
  align-items: center;
`;

export const ButtonBox = styled.div`
  display: block;
  width: 82px;
  height: 82px;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 82px;
  height: 82px;

  span {
    text-indent: -9999px;
  }

  &.notice {
    background: ${({ theme }) => theme.themeColor.main_1};
  }

  &.delete {
    background: ${({ theme }) => theme.themeColor.negative2};
  }
`;
